
        var result = require("!!../../../../node_modules/css-loader/index.js!./article-price-change.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-cashreg/article-price-change.component.css
// module id = 2364
// module chunks = 1